/* eslint-disable react/no-danger */
import { Image, UIHeading2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './PurchaseTermDescriptionModal.css';

interface IPurchaseTermDescriptionModalProps {
  imageUrl: string;
  title: string;
  description: string;
}

export const PurchaseTermDescriptionModal: React.FC<IPurchaseTermDescriptionModalProps> = ({
  imageUrl,
  title,
  description,
}) => {
  return (
    <div className={styles['content']} data-testid="PurchaseTermDescriptionModal">
      <div className={styles['image']}>
        <Image src={imageUrl} height={200} width="100%" objectFit="cover" />
      </div>
      <div className={styles['description']}>
        <UIHeading2>{title}</UIHeading2>
        <div className={styles['description-text']}>{description}</div>
      </div>
    </div>
  );
};
